/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will it change the order of my lines?`)
};

const es_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cambiará el orden de mis líneas?`)
};

const de_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird die Reihenfolge meiner Zeilen geändert?`)
};

const nl_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zal het de volgorde van mijn regels veranderen?`)
};

const fr_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'outil va-t-il modifier l'ordre de mes lignes ?`)
};

const it_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambierà l'ordine delle mie righe?`)
};

const pt_br2_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudará a ordem das minhas linhas?`)
};

const pt_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alterar a ordem das minhas linhas?`)
};

const ja_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行の順序が変わりますか?`)
};

const zh_rd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会改变我文本行的顺序吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq4_q", locale)
	if (locale === "en") return en_rd_faq4_q(inputs)
	if (locale === "es") return es_rd_faq4_q(inputs)
	if (locale === "de") return de_rd_faq4_q(inputs)
	if (locale === "nl") return nl_rd_faq4_q(inputs)
	if (locale === "fr") return fr_rd_faq4_q(inputs)
	if (locale === "it") return it_rd_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq4_q(inputs)
	if (locale === "pt") return pt_rd_faq4_q(inputs)
	if (locale === "ja") return ja_rd_faq4_q(inputs)
	return zh_rd_faq4_q(inputs)
};